import React from 'react';
import styled from '../../theme';
const Bar = styled.ul `
  list-style: none;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 10px 0 0 0;
`;
const Wrapper = styled.li `
  position: relative;
  display: inline-block;
  width: 15px;
  margin: 0 3px;
  &.active {
    button {
      &:before {
        opacity: .75;
      }
    }
  }
`;
const Buttons = styled.button `
font-size: 0;
line-height: 0;

display: block;

width: 20px;
height: 20px;
padding: 5px;

cursor: pointer;

color: transparent;
border: 0;
outline: none;
background: transparent;

  &:before {
  font-family: 'slick';
  font-size: 25px;
  line-height: 20px;

  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: '•';
  text-align: center;
  opacity: .25;
  color: ${(props) => props.theme.brandPrimary};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  @media ${(props) => props.theme.mq.md} { 
    font-size: 40px;
  }
  }
`;
const getDots = (length, active, onClickHandler) => {
    const dots = [];
    for (let i = 0; i < length; i += 1) {
        const isActive = (i === active);
        dots.push(React.createElement(Wrapper, { key: `dotWrap${i}`, className: `${isActive ? 'active' : ''}`, onClick: () => onClickHandler(i) },
            React.createElement(Buttons, { "aria-label": `${i}` })));
    }
    return dots;
};
const Dots = ({ length, active, onClickHandler }) => {
    if (length <= 1) {
        return null;
    }
    return (React.createElement(Bar, null, getDots(length, active, onClickHandler)));
};
export default Dots;
